import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求权限列表
export const getPermissionList = params => {
    return get("/admin/permissions", params);
};
// 添加权限
export const addPermission = params => {
    return post("/admin/permissions", params);
};
// 修改信息
export const editPermission = params => {
    return put(`/admin/permissions/${params.id}`, params);
};
// 删除权限
export const deletePer = params => {
    return del(`/admin/permissions/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/permission.js